export const moveOrDeleteToolMessage = (toolMessage: any, results: any, toolName: string) => {
    if (results.errorMessage) {
        const content = [{type: 'text', text: results.errorMessage}];
        return  {...toolMessage, content: content};
    }
    const operation = toolName === "deleteFile" ? "delete" : "moved";

    const content = [{
        type: 'text',
        text: `File successfully ${operation}!`
    }];

    return {...toolMessage, content: content};
}
